// Shared service-type catalogue for Register, Discover Rentals, and any
// future surface that needs to know which rental categories ConfirmPH
// currently supports. Active categories can be selected/filtered;
// "coming soon" categories are visible but disabled.

export const ACTIVE_SERVICE_TYPES = [
  { value: "car_rental",                 label: "Car rental" },
  { value: "motorbike_rental",           label: "Motorbike rental" },
  { value: "car_and_motorbike_rental",   label: "Car & motorbike rental" },
];

export const COMING_SOON_SERVICE_TYPES = [
  { value: "van_rental",                 label: "Van rental" },
  { value: "equipment_rental",           label: "Equipment rental" },
  { value: "party_event_rental",         label: "Party / event rental" },
  { value: "tool_rental",                label: "Tool rental" },
  { value: "resort_hotel_stay",          label: "Resort / hotel / stay" },
  { value: "tour_operator",              label: "Tour operator" },
  { value: "boat_water_activity",        label: "Boat / water activity rental" },
  { value: "construction_materials",     label: "Construction / materials rental" },
  { value: "other_rental",               label: "Other rental service" },
];

export const ALL_SERVICE_TYPES = [...ACTIVE_SERVICE_TYPES, ...COMING_SOON_SERVICE_TYPES];

export const ACTIVE_SERVICE_VALUES = new Set(ACTIVE_SERVICE_TYPES.map((s) => s.value));

export const COMING_SOON_MESSAGE =
  "Coming soon. ConfirmPH is starting with car and motorbike rentals first.";

export function labelForServiceType(value) {
  return ALL_SERVICE_TYPES.find((s) => s.value === value)?.label || value;
}
